import {configMultipart, getHttp} from "@/api/config/http-configs";

// 统一走 mobile 上传（任意 mobile token，含 TERMINAL）
export const uploadFileWithServe = (file, path) => {
    const url = '/mobile/file/upload'
    const formData = new FormData();
    formData.append('file', file);
    formData.append('path', path);
    return getHttp().post(url, formData, configMultipart)
}

function base64ToFile(base64String, filename) {
    const arr = base64String.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
}

export const uploadBase64FileWithServe = (file, path) => {
    const url = '/mobile/file/upload';
    const formData = new FormData();
    if (!file.startsWith('data:image')) {
        file = "data:image/jpeg;base64," + file;
    }

    const fileName = path.split('/').pop();
    // 将 base64 编码的图片转换为文件对象
    const convertedFile = base64ToFile(file, fileName);
    formData.append('file', convertedFile);
    formData.append('path', path);

    return getHttp().post(url, formData, configMultipart);
};
